export enum CompanyCodeEnum {
  PLAZZA = '1',
  GURUS = '2',
}

export enum TypePersonBPEnum {
  JURIDICO = 'TP0002'
}